/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_5_DescInputs */

const en_vc_ft_5_desc = /** @type {(inputs: Vc_Ft_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spin a profile into a 3D object with smooth vector shading, caps and an on-canvas rotation gizmo.`)
};

const zh_vc_ft_5_desc = /** @type {(inputs: Vc_Ft_5_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`把轮廓旋转成带平滑矢量明暗的 3D 对象，支持端盖和画布上的旋转控件。`)
};

/**
* | output |
* | --- |
* | "Spin a profile into a 3D object with smooth vector shading, caps and an on-canvas rotation gizmo." |
*
* @param {Vc_Ft_5_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_5_desc = /** @type {((inputs?: Vc_Ft_5_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_5_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_5_desc(inputs)
	return zh_vc_ft_5_desc(inputs)
});
export { vc_ft_5_desc as "vc.ft.5.desc" }